import React, { useEffect, useState } from "react";
import Router from "@/router/index";

function App() {
  return (
    <div>
      <Router />
    </div>
  );
}

export default App;
